/** Token-backed class strings for shell chrome (dark/light parity). */

export const shell = {
  canvas: 'bg-[var(--shell-canvas)] text-[var(--shell-fg)]',
  surface: 'bg-[var(--shell-surface)] text-[var(--shell-fg)]',
  surfaceElevated: 'bg-[var(--shell-surface-elevated)] text-[var(--shell-fg)]',
  border: 'border-[var(--shell-border)]',
  muted: 'text-[var(--shell-fg-muted)]',
  subtle: 'text-[var(--shell-fg-subtle)]',
  accent: 'text-[var(--shell-accent)]',
  accentBg: 'bg-[var(--shell-accent-muted)] text-[var(--shell-accent)]',
  hoverRow: 'hover:bg-[var(--shell-hover)]',
  focusRing:
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--shell-focus-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--shell-surface)]',
  control:
    'min-h-[44px] rounded-[var(--shell-radius-md)] border border-[var(--shell-border)] bg-[var(--shell-surface-elevated)] px-3 text-sm text-[var(--shell-fg)] transition-colors duration-[var(--shell-motion-fast)]',
  controlIcon:
    'inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-[var(--shell-radius-md)] border border-[var(--shell-border)] bg-[var(--shell-surface-elevated)] text-sm text-[var(--shell-fg)] transition-colors duration-[var(--shell-motion-fast)] hover:bg-[var(--shell-hover)]',
  sidebar:
    'border-r border-[var(--shell-border)] bg-[var(--shell-sidebar)] text-[var(--shell-fg)]',
  topbar:
    'border-b border-[var(--shell-border)] bg-[var(--shell-topbar)]/95 backdrop-blur supports-[backdrop-filter]:bg-[var(--shell-topbar)]/90',
  footer: 'border-t border-[var(--shell-border)] bg-[var(--shell-surface)] text-[var(--shell-fg-muted)]',
} as const;
